export default __webpack_public_path__ + "maps-examples-fly-to-thumbnail-960-f7503fe8aa9be1bccbd584fd0ff329df.png";